import api from './api';

export const cartService = {
  // Get user's cart
  getCart: async () => {
    const response = await api.get('/cart');
    return response.data?.data || response.data;
  },

  // Add item to cart
  addToCart: async (productId, quantity = 1, colorId = null) => {
    const response = await api.post('/cart/add', {
      product_id: productId, // Backend expects product_id, not productId
      quantity,
      color_id: colorId,
    });
    return response.data?.data || response.data;
  },

  // Update cart item quantity
  updateCartItem: async (itemId, quantity) => {
    const response = await api.put(`/cart/update/${itemId}`, {
      quantity,
    });
    return response.data?.data || response.data;
  },

  // Remove item from cart
  removeFromCart: async itemId => {
    const response = await api.delete(`/cart/remove/${itemId}`);
    return response.data?.data || response.data;
  },

  // Clear entire cart
  clearCart: async () => {
    const response = await api.delete('/cart/clear');
    return response.data?.data || response.data;
  },
};
